import { FormFields } from "@/types";
import { timeZoneList } from "@/lib/helpers/time";
import { listToDropdownList } from "@/lib/helpers/listHelpers";
import { $t } from "@/lib/helpers/i18nHelper";
import config from "@/config";

let fields: FormFields = [
  {
    name: "username",
    title: $t("Username"),
    clearable: false,
  },
  {
    name: "screenName",
    title: $t("Screen Name"),
    clearable: false,
  },
  {
    name: "role",
    title: $t("Role"),
    type: "select",
    clearable: false,
    list: config.userRoleList.map(role => ({ value: role, text: $t(role) })),
  },
  {
    name: "timeZone",
    title: $t("Time zone"),
    type: "autocomplete",
    list: listToDropdownList(timeZoneList),
    clearable: false,
  },
];

if (config.featureCustomDomain) {
  fields.push({
    name: "domain",
    title: $t("Domain name"),
    clearable: false,
  });
}

if (config.featurePhoneSignUp) {
  fields.splice(2, 0, {
    name: "phone",
    title: $t("Phone"),
    clearable: false,
  });
  fields.splice(4, 0, {
    name: "email",
    title: $t("Email"),
    clearable: false,
  });
} else {
  fields.splice(2, 0, {
    name: "email",
    title: $t("Email"),
    clearable: false,
  });
}

export { fields };
